//* DonatingPortal(기부 대기 화면)과 같은 값 — expo-out은 구간 20%에서 이미 불투명도 75%에 닿아 '툭' 나타난다.
export const FADE_DURATION = 0.24;
export const EXIT_DURATION = 0.2;

//* 목록은 레이어보다 빠르게 — 5행 기준 마지막 행까지 0.3초 안에 끝난다(0.07 간격은 0.74초라 느리게 읽혔다).
export const ROW_DELAY_SECONDS = 0.02;
export const ROW_STAGGER_SECONDS = 0.03;
export const ROW_FADE_DURATION = 0.16;
